<template>
  <div class="md-collapse">
    <md-list>
      <li v-if="user.roles && user.roles.length > 0">
        <md-field>
          <label for="activeAccount">{{$t('pages.dashboard.account')}}</label>
          <md-select name="activeAccount" id="activeAccount" v-model="activeAccountId">
            <md-option v-for="role in user.roles" v-bind:value="role.mys_account">{{role.accountName}}</md-option>
          </md-select>
        </md-field>
      </li>
      <md-list-item href="#" class="dropdown">
        <drop-down>
          <a slot="title" class="dropdown-toggle" data-toggle="dropdown" v-on:click="logout">
            {{$t('buttons.logout')}}<i class="material-icons">person</i>
            <p class="hidden-lg hidden-md">{{$t('pages.dashboard.profile')}}</p>
          </a>
        </drop-down>
      </md-list-item>
    </md-list>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: 'account-selector',
  props: {
    activeAccountId: {},
    logout: {}
  },
  computed:{
    ...mapGetters(["user"]),
  }
}
</script>